import React, { useState } from "react";
import "../assets/style/pages/Contact.scss";

const Contact = () => {

    const [showConfirmation, setShowConfirmation] = useState(false);
    const triggerConfirmation = () => {
        setShowConfirmation(true);
        setTimeout(() => setShowConfirmation(false), 2000);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        try{
            const formData = {
                nom: e.target.nom.value,
                prenom: e.target.prenom.value,
                email: e.target.email.value,
                telephone: e.target.telephone.value,
                sujet: e.target.sujet.value,
                message: e.target.message.value,
            };

            const response = await fetch("/api/mail.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            if (response.ok){
                triggerConfirmation();
            }
        }catch(err){
            console.error('Error :', err);
        }
        
    };

    return (
        <div className="page-container">
            <div className="centered-row-container">
                <div className="col-lg-8 col-md-10 centered-column-container section">
                    <div className="page-header">
                        <h1 className="page-title">Contactez-nous</h1>
                        <p className="page-subtitle">Vous avez une question, une suggestion ou besoin d'assistance ? <br />N'hésitez pas à nous contacter en remplissant le formulaire ci-dessous.</p>
                    </div>
                    <form className="gap-4 d-flex flex-column w-100" method="POST" onSubmit={handleSubmit}>
                        <div className="row gap-lg-0 gap-4">
                            <div className="col-md-6">
                                <input className="form-input" type="text" id="nom" name="nom" aria-label="Nom" placeholder="Nom" required />
                            </div>
                            <div className="col-md-6">
                                <input className="form-input" type="text" id="prenom" name="prenom" aria-label="Prénom" placeholder="Prénom" required />
                            </div>
                        </div>
                        <div className="row gap-lg-0 gap-4">
                            <div className="col-lg-9">
                                <input className="form-input" type="email" id="email" name="email" aria-label="E-Mail" placeholder="E-Mail" required />
                            </div>
                            <div className="col-lg-3">
                                <input className="form-input" type="tel" id="telephone" name="telephone" aria-label="Téléphone" placeholder="Téléphone" />
                            </div>
                        </div>
                        <div>
                            <select className="form-input" id="sujet" name="sujet" aria-label="Sujet" defaultValue={"Sujet"}required>
                                <option value="Demande d'information">Demande d'information</option>
                                <option value="Support technique">Support technique</option>
                                <option value="Suggestion">Suggestion</option>
                                <option value="Autre">Autre</option>
                            </select>
                        </div>
                        <div>
                            <textarea id="message" name="message" rows="5" aria-label="Message" placeholder="Votre message" required></textarea>
                        </div>
                        <div className="centered-row-container">
                            <button type="submit" className="action-btn large"><div>Envoyer</div></button>
                        </div>
                    </form>
                </div>
            </div>
            {showConfirmation && (<div className="position-fixed bottom-0 start-0 mb-5 w-100 d-flex justify-content-center">
                <div className="confirmation-popup bold">
                    Merci pour votre message, il sera traité au plus vite ! 
                </div>
            </div>)}
        </div>
    );
}

export default Contact;